import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { BadgePenaltyCounter } from "@src/appV2/redesign/WorkBadges/components/Policy/BadgePenaltyCounter";

import { BadgeVerificationExplanationLayout } from "./BadgeVerificationExplanationLayout";
import { BadgeVerificationResultType } from "./hooks/useShouldShowBadgeVerificationResult";

const MAX_STRIKE_COUNT = 3;

interface BadgeVerificationStrikesStepProps {
  type: BadgeVerificationResultType;
  strikeCount: number;
  onViewBadgePolicy: () => void;
  onNext: () => void;
}

function getStrikesStepTitle(type: BadgeVerificationResultType): string {
  if (type === BadgeVerificationResultType.SHOW_SKIPPED) {
    return "You skipped badge verification";
  }

  return "Your badge was not verified";
}

export function BadgeVerificationStrikesStep(props: BadgeVerificationStrikesStepProps) {
  const { type, strikeCount, onViewBadgePolicy, onNext } = props;

  return (
    <BadgeVerificationExplanationLayout
      title={getStrikesStepTitle(type)}
      onViewBadgePolicy={onViewBadgePolicy}
      onNext={onNext}
    >
      <Stack direction="row" spacing={4} justifyContent="center">
        {Array.from({ length: MAX_STRIKE_COUNT }).map((_, index) => (
          <BadgePenaltyCounter
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isFilled={index < strikeCount}
          />
        ))}
      </Stack>

      <Text
        variant="body2"
        color={(theme) => theme.palette.text.primary}
        sx={{ textAlign: "center" }}
      >
        Missing badge verification 3 times within 60 days will restrict you from badge-required
        workplaces for 30 days.
      </Text>
    </BadgeVerificationExplanationLayout>
  );
}
